import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerTwitterAnalyticsPosts.graphql';
import { Query, QueryinfluencerTwitterAnalyticsPostsArgs } from '../../__generated__/globalTypes';

export const useInfluencerTwitterAnalyticsPostsQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerTwitterAnalyticsPostsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerTwitterAnalyticsPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerTwitterAnalyticsPostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerTwitterAnalyticsPostsArgs>
): QueryResult<Query, QueryinfluencerTwitterAnalyticsPostsArgs> & {
  getInfluencerTwitterAnalyticsPosts: LazyQueryExecFunction<Query, QueryinfluencerTwitterAnalyticsPostsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerTwitterAnalyticsPosts, result] = useLazyQuery<Query, QueryinfluencerTwitterAnalyticsPostsArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getInfluencerTwitterAnalyticsPosts, ...result };
};

export const useInfluencerTwitterAnalyticsPostsPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerTwitterAnalyticsPosts = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerTwitterAnalyticsPostsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerTwitterAnalyticsPostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerTwitterAnalyticsPosts };
};
// Suspense Query Hooks
export const useInfluencerTwitterAnalyticsPostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerTwitterAnalyticsPostsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerTwitterAnalyticsPostsArgs>(QUERY, {
    ...options
  });

  return result;
};
